export const SERVICES = [
  {
    slug: 'software-development',
    id: 1,
    title: 'Software Development',
    short: 'Software Solutions',
    focus: 'Software',
    group: 'Software',
    description: 'Modern software engineering for web, mobile, enterprise platforms and custom business applications.',
    longDescription: 'Our software practice is the core of Afrikkom Global. We design and build scalable digital products, customer portals, internal platforms and custom business applications that help organizations improve operations and create better digital experiences.',
    icon: '</>',
    features: [
      'Web application development',
      'Mobile application development',
      'Enterprise platforms & portals',
      'UI/UX and product engineering',
      'Custom business applications',
      'System integration & automation'
    ],
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1600&q=76'
  },
  {
    slug: 'ai-intelligent-automation',
    id: 2,
    title: 'AI & Intelligent Automation',
    short: 'AI & Automation',
    focus: 'AI',
    group: 'Software',
    description: 'AI-powered solutions and intelligent automation that turn data, workflows and business processes into measurable outcomes.',
    longDescription: 'We help organizations apply AI where it creates practical value. From AI assistants and intelligent search to document processing, workflow automation, analytics and decision-support systems, we connect AI capabilities with real business processes and existing technology.',
    icon: '✦',
    features: [
      'AI assistants & copilots',
      'Intelligent workflow automation',
      'Document intelligence',
      'AI-powered search & knowledge systems',
      'Predictive analytics & reporting',
      'AI integration with existing platforms'
    ],
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1600&q=76'
  },
  {
    slug: 'cloud-api-digital-platforms',
    id: 3,
    title: 'Cloud, API & Digital Platforms',
    short: 'Cloud & Platforms',
    focus: 'Platforms',
    group: 'Software',
    description: 'Scalable backend systems, APIs, cloud services and connected digital platforms built for modern businesses.',
    longDescription: 'We engineer the technology layer behind digital businesses — from backend services and APIs to cloud-connected platforms, third-party integrations and data-driven systems.',
    icon: '◉',
    features: [
      'Backend & API development',
      'Cloud application development',
      'Third-party integrations',
      'Database & data architecture',
      'Microservices & connected systems',
      'Monitoring, maintenance & support'
    ],
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1600&q=76'
  },

  /* =========================
     TELECOM SERVICES
     ========================= */

  {
    slug: 'drive-test-optimization',
    id: 4,
    title: 'Drive Test & Optimization',
    short: 'Drive Test & Optimization',
    focus: 'Telecom',
    group: 'Telecom',
    description: 'End-to-end mobile network testing, benchmarking, KPI analysis and RF optimization to improve coverage, capacity, quality and customer experience.',
    longDescription: 'Our Drive Test & Optimization practice combines field measurements with engineering analysis to identify coverage gaps, capacity constraints, interference, handover issues and service-quality problems. We support 2G, 3G, 4G/LTE and 5G programs from test planning through post-processing, optimization and validation.',
    icon: '⌁',
    features: [
      'Drive test planning & execution',
      'Cluster and route testing',
      '2G / 3G / 4G / LTE / 5G testing',
      'RF and KPI analysis',
      'Coverage & capacity analysis',
      'Benchmarking and competitive benchmarking',
      'Call quality and data performance testing',
      'Coverage-hole and interference analysis',
      'Handover and neighbor analysis',
      'Parameter optimization',
      'VoLTE / data performance validation',
      'Post-processing, reporting & acceptance'
    ],
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1600&q=76'
  },
  {
    slug: 'ran-microwave-installation',
    id: 5,
    title: 'RAN & Microwave Installation',
    short: 'RAN & RAN & MW Installation',
    focus: 'Telecom',
    group: 'Telecom',
    description: 'End-to-end RAN and microwave installation, integration, commissioning and transmission deployment for modern mobile networks.',
    longDescription: 'Our field engineering teams support RAN and microwave deployment across the network lifecycle, from equipment and antenna installation to integration, commissioning, microwave link alignment, backhaul deployment and site acceptance. We support 2G, 3G, 4G and 5G rollout, modernization and transmission programs.',
    icon: '◈',
    features: [
      'BTS / eNodeB / gNodeB installation',
      'RRU / RRH and antenna installation',
      'Baseband, cabinet and rack installation',
      'Feeder and cable installation',
      'RAN site integration and commissioning',
      '4G / 5G rollout and modernization',
      'Site acceptance and installation audits',
      'Microwave link planning and site surveys',
      'PTP / PTMP microwave deployment',
      'IDU / ODU installation',
      'Antenna alignment and LOS verification',
      'Link budget and capacity analysis',
      'Backhaul commissioning and integration',
      'Microwave performance testing and optimization'
    ],
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1600&q=76'
  },
  {
    slug: 'fiber-transmission-engineering',
    id: 7,
    title: 'Fiber & Transmission Engineering',
    short: 'Fiber & Transmission',
    focus: 'Telecom',
    group: 'Telecom',
    description: 'Fiber, transport and backhaul engineering supporting resilient connectivity, network expansion, testing and documentation.',
    longDescription: 'We support fiber and transmission programs with planning, route engineering, deployment support, testing, backhaul coordination and technical documentation. These services complement RAN and microwave delivery to provide a broader network infrastructure capability.',
    icon: '≋',
    features: [
      'Fiber network planning',
      'Fiber route design',
      'Backhaul engineering',
      'Transport network support',
      'Fiber deployment coordination',
      'OTDR and link testing',
      'Transmission performance validation',
      'Network expansion support',
      'Site and route documentation',
      'Troubleshooting and technical reporting'
    ],
    image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=1600&q=76'
  },
  {
    slug: 'network-planning-managed-services',
    id: 8,
    title: 'Network Planning, Audits & Managed Services',
    short: 'Planning & Managed Services',
    focus: 'Telecom',
    group: 'Telecom',
    description: 'Network planning, technical audits, performance management and ongoing engineering support for multi-vendor environments.',
    longDescription: 'We provide engineering and advisory support across the network lifecycle, from RF and capacity planning to technical audits, benchmarking, KPI monitoring, fault and performance management, and continuous optimization.',
    icon: '◎',
    features: [
      'RF and coverage planning',
      'Capacity and dimensioning studies',
      'Network health audits',
      'Technical and site audits',
      'Performance and KPI monitoring',
      'Network benchmarking',
      'RAN performance management',
      'Fault and configuration support',
      'IBS / DAS / small-cell engineering support',
      'Multi-vendor engineering support',
      'Optimization strategy',
      'Technical reporting and documentation'
    ],
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1600&q=76'
  },
  {
    slug: 'payroll-consulting',
    id: 9,
    title: 'Payroll & Consulting',
    short: 'Payroll & Consulting',
    focus: 'Consulting',
    group: 'Consulting',
    description: 'Practical payroll operations and business consulting that help teams stay organized, efficient and focused.',
    longDescription: 'Our consulting offering supports organizations with payroll processes, workforce administration, operational documentation and practical business support.',
    icon: '◎',
    features: [
      'Payroll processing support',
      'Workforce administration',
      'Payroll reporting',
      'Process documentation',
      'Operational consulting',
      'Business support services'
    ],
    image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1600&q=76'
  }
];

export const SERVICE_BY_SLUG = Object.fromEntries(SERVICES.map(s => [s.slug, s]));

export const ECOSYSTEM = [
  { 
    name: 'Ericsson', 
    logo: 'https://logos-marcas.com/wp-content/uploads/2020/12/Ericsson-Simbolo.png', 
    link: 'https://www.ericsson.com' 
  },
  { 
    name: 'Huawei', 
    logo: 'https://tse4.mm.bing.net/th/id/OIP.hpFOE65hxKmb-l_zoNlIYgAAAA?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3', 
    link: 'https://www.huawei.com' 
  },
  { 
    name: 'Mascom', 
    logo: 'https://online.mascom.bw/images/thumbs/0000007_logo.png', 
    link: 'https://www.mascom.bw' 
  },
  { 
    name: 'BTC', 
    logo: 'https://yt3.ggpht.com/a/AATXAJzyYeCvs61IrZpUF5TfpYXRsUs1BLr8HpR0bg=s900-c-k-c0xffffffff-no-rj-mo', 
    link: 'https://www.btc.bw' 
  },
  { 
    name: 'Orange', 
    logo: 'https://etisalangy.com/wp-content/uploads/2023/10/%D9%83%D9%88%D8%AF-%D8%B1%D8%B3%D8%A7%D8%A6%D9%84-%D8%B6%D8%A8%D8%B7-%D8%A7%D9%84%D8%A7%D9%86%D8%AA%D8%B1%D9%86%D8%AA-%D8%A7%D9%88%D8%B1%D9%86%D8%AC-%D8%A7%D9%84%D8%A7%D8%B1%D8%AF%D9%86.jpg', 
    link: 'https://www.orange.com' 
  },

  {
    name: 'Nokia',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/02/Nokia_wordmark.svg',
    link: 'https://www.nokia.com'
  },
  { 
    name: 'Toyota', 
    logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9d/Toyota_carlogo.svg', 
    link: 'https://www.toyota.com' 
  },
  { 
    name: 'HomeLight', 
    logo: 'https://images.seeklogo.com/logo-png/44/1/homelight-logo-png_seeklogo-443600.png', 
    link: 'https://www.homelight.com' 
  },
  { 
    name: 'Snapdeal', 
    logo: 'https://images.yourstory.com/cs/wordpress/2016/09/snapdeal-new-logo.png', 
    link: 'https://www.snapdeal.com' 
  },
  { 
    name: 'Pixely AI', 
    logo: 'https://images.squarespace-cdn.com/content/v1/626840817cdb871c34a9ed4b/32d495e0-0fed-430a-98a3-f6b92684314f/Pixel+AI.png?format=1500w', 
    link: 'https://pixely.ai' 
  },
  { 
    name: 'Teachfloor', 
    logo: 'https://www.teachfloor.com/images/teachfloor-logo-v4.svg?dpl=dpl_DYcxb7bYRvw8WdQTR79ffQcav1', 
    link: 'https://www.teachfloor.com' 
  }
];


export const SOCIAL_LINKS={linkedin:'https://www.linkedin.com/company/afrikkomglobal/'};
export const COMPANY_INFO={name:'AfriKKom Global Pty Ltd',email:'Info@afrikkomglobal.com',phone:'+267 74367711',address:'InnoSpace The Hub, First Floor, Plot 54368, CBD, PO Box 794 AAH, Masa Centre, Gaborone, Botswana',founded:2023};
export const LOCATIONS=[['Global Delivery','Worldwide','Digital & Telecom Delivery'],['North America','Client & Project Delivery','Software & Digital'],['Europe','Client & Project Delivery','Software & Digital'],['Middle East','Client & Project Delivery','Software & Telecom'],['Asia-Pacific','Client & Project Delivery','Software & Telecom']];
